import { Directive, ElementRef, Renderer2, OnInit, OnDestroy } from '@angular/core';
import { StateSidebarService } from '../services/state-sidebar.service';
import { Subscription } from 'rxjs';
import { ESidebarState } from '../enumerables/sidebarState';
import { ESidebarPosition } from '../enumerables/sidebarPosition';

@Directive({
  selector: '[state-sidebar]'
})
export class StateSidebarDirective implements OnInit, OnDestroy {

  private stateSubscription: Subscription;
  private positionSubscription: Subscription;
  private state: boolean;
  private position: boolean;

  constructor(
    private element: ElementRef,
    private render: Renderer2,
    private sidebarService: StateSidebarService
  ) {
  }

  public ngOnInit(): void {
    /*
      sidebar-fixed
      sidebar-float
    */
    this.stateSubscription = this.sidebarService.stateSource.subscribe((state: ESidebarState) => {
      switch (state) {
        case ESidebarState.open:
          this.render.addClass(this.element.nativeElement, 'open');
          break;
        case ESidebarState.closed:
          this.render.removeClass(this.element.nativeElement, 'open');
          break;
        default:
          break;
      }
    });

    /*
      sidebar-fixed
      sidebar-float
    */
    this.positionSubscription = this.sidebarService.positionSource.subscribe((position: ESidebarPosition) => {
      this.render.removeClass(this.element.nativeElement, 'sidebar-fixed');
      this.render.removeClass(this.element.nativeElement, 'sidebar-float');
      switch (position) {
        case ESidebarPosition.fixed:
          this.render.addClass(this.element.nativeElement, 'sidebar-fixed');
          break;
        case ESidebarPosition.float:
          this.render.addClass(this.element.nativeElement, 'sidebar-float');
          break;
        default:
          break;
      }
    });
  }

  public ngOnDestroy(): void {
    this.stateSubscription.unsubscribe();
    this.positionSubscription.unsubscribe();
  }
}
